module.exports = __webpack_public_path__ + "img/entertainment-1-640.dd00cad1.jpg";